// tsumugiec-166: スライド枚数ぶんのドットを作り、スワイプ位置に合わせて点灯させる
if (!customElements.get('card-gallery-dots')) {
    class CardGalleryDots extends HTMLElement {
        connectedCallback() {
            this.slides = this.closest('.card-gallery')?.querySelector('slideshow-slides');
            if (!this.slides) return;
            this.onScroll = () => this.update();
            this.slides.addEventListener('scroll', this.onScroll, { passive: true });
            this.render();
        }

        disconnectedCallback() {
            this.slides?.removeEventListener('scroll', this.onScroll);
        }

        render() {
            const count = this.slides.querySelectorAll('slideshow-slide').length;
            this.hidden = count < 2;
            this.replaceChildren(...Array.from({ length: count }, () => document.createElement('span')));
            this.update();
        }

        update() {
            const width = this.slides.clientWidth;
            if (!width) return;
            const index = Math.round(this.slides.scrollLeft / width);
            Array.from(this.children).forEach((dot, i) => dot.toggleAttribute('data-active', i === index));
        }
    }
    customElements.define('card-gallery-dots', CardGalleryDots);
}